import React, { useRef } from "react";
import Slider from "react-slick";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import StarIcon from "@mui/icons-material/Star";
// import customer1 from "/images/customer1.jpg";
// import customer2 from "/images/customer2.jpg";
// import customer3 from "/images/customer3.jpg";
// import customer4 from "/images/customer4.jpg";
// import customer5 from "/images/customer5.jpg";
import { Box } from "@mui/material";

interface CustomerReviewProps {}

const CustomerReview: React.FC<CustomerReviewProps> = (props) => {
  const sliderCustomerRef = useRef<Slider>(null);

  const slickCustomerSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    // nextArrow: <></>,
    // prevArrow: <></>,
  };

  const customers = [
    {
      name: "Lê Bảo Hân",
      role: "Giảng viên",
      start: 5,
      content:
        "Tôi rất hài lòng với dịch vụ vệ sinh máy lạnh của công ty! Nhân viên đến đúng giờ, làm việc nhanh chóng và chuyên nghiệp. Sau khi vệ sinh xong, máy lạnh chạy êm hơn hẳn và mát nhanh hơn trước rất nhiều. Giá cả hợp lý, không phát sinh thêm chi phí.",
      image: "/images/customer1.jpg",
    },
    {
      name: "Nguyễn Gia Linh",
      role: "Giáo viên",
      start: 5,
      content:
        "Dịch vụ sửa chữa máy lạnh quá tuyệt vời! Máy lạnh nhà tôi bị chảy nước và không mát, kỹ thuật viên đến kiểm tra tận tình, báo đúng bệnh. Sau khi sửa xong, máy chạy ổn định, không còn rò rỉ nước. Tôi đánh giá cao sự trung thực và kỹ năng chuyên môn của đội ngũ.",
      image: "/images/customer2.jpg",
    },
    {
      name: "Nguyễn Ngọc Ánh",
      role: "Nhân viên văn phòng",
      start: 4,
      content:
        "Lần đầu sử dụng dịch vụ nhưng tôi cực kỳ ấn tượng. Đội ngũ nhân viên rất lịch sự, gọn gàng và có trách nhiệm. Máy lạnh sau khi vệ sinh sạch bong, chạy mát lạnh như mới. Quá trình làm việc được giải thích rõ ràng và minh bạch, không hề chèo kéo hay báo giá sai.",
      image: "/images/customer3.jpg",
    },
    {
      name: "Lê Minh",
      role: "Sinh viên",
      start: 4,
      content:
        "Tôi đã gọi dịch vụ vệ sinh máy lạnh định kỳ hàng năm và luôn chọn đơn vị này vì chất lượng ổn định, nhân viên thân thiện và đúng hẹn. Không làm ảnh hưởng đến không gian trong nhà. Dịch vụ đáng tin cậy, rất đáng để giới thiệu cho người thân và bạn bè.",
      image: "/images/customer4.jpg",
    },
    {
      name: "Trần Văn Huy",
      role: "Nhân viên văn phòng",
      start: 4,
      content:
        "Máy lạnh nhà tôi bị hư không rõ nguyên nhân, may mắn là gọi được dịch vụ này. Kỹ thuật viên đến nhanh, kiểm tra kỹ lưỡng và sửa chữa rất có tâm. Cảm giác rất an tâm và hài lòng với cách làm việc chuyên nghiệp như vậy.",
      image: "/images/customer5.jpg",
    },
  ];
  return (
    <section id="customer-reviews" className=" lg:px-20 bg-white lg:py-5">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left Content */}
        <div>
          <h2 className="text-xl px-3 lg:px-0 lg:text-4xl font-bold text-gray-900 mb-4">
            Khách hàng nói gì về chúng tôi
          </h2>
          <p className=" px-3 lg:px-0 text-gray-600 text-base mb-8 max-w-md">
            Đọc những gì khách hàng nói về chúng tôi để biết được dịch vụ của
            chúng tôi khác biệt với các đơn vị khác như thế nào.
          </p>
          <div className="flex  px-3 lg:px-0 gap-4">
            <button
              onClick={() => sliderCustomerRef.current?.slickPrev()}
              className="w-10 h-10 border border-primary_blue text-primary_blue rounded-lg flex items-center justify-center hover:bg-blue-200 transition"
            >
              <WestIcon fontSize="small" />
            </button>
            <button
              onClick={() => sliderCustomerRef.current?.slickNext()}
              className="w-10 h-10 bg-primary_blue text-white rounded-lg flex items-center justify-center hover:bg-primary_blue transition"
            >
              <EastIcon fontSize="small" />
            </button>
          </div>
        </div>

        {/* Right Testimonial Card */}
        <Slider ref={sliderCustomerRef} {...slickCustomerSettings}>
          {customers.map((customer, index) => (
            <div className=" px-3" key={index}>
              <div className="!flex relative bg-white border-t-4 border-r-4 border-primary_blue rounded-3xl p-6  gap-4 !shadow-md items-start">
                <img
                  src={customer.image}
                  alt={customer.name}
                  className="w-28 object-cover rounded-xl"
                />
                <div className="flex-1 space-y-2">
                  <h3 className="text-lg font-semibold !flex items-center">
                    {customer.name}{" "}
                    <p className="text-sm font-light text-gray-500">
                      &nbsp;({customer.role})
                    </p>{" "}
                  </h3>

                  {/* Rating */}
                  <div className="flex space-x-1 text-yellow-400">
                    <Box className="flex">
                      {[...Array(5)].map((_, i) => (
                        <StarIcon
                          key={i}
                          className={
                            i < customer.start
                              ? "text-yellow-500"
                              : "text-gray-300"
                          }
                        />
                      ))}
                    </Box>
                  </div>
                  {/* Review content */}
                  <p className="text-sm text-gray-700">{customer.content}</p>
                </div>

                {/* Quotation mark */}
                <div className="absolute top-3 right-4">
                  <div className="bg-primary_blue w-10 h-10 flex items-center justify-center rounded-md">
                    <FormatQuoteIcon className="text-white" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default CustomerReview;
